export interface Cache<K, V> {
  get(key: K): V | undefined;
  set(key: K, value: V): void;
  clear(): void;
}

export function createCache<K, V>(size: number): Cache<K, V> {
  const store = new Map<K, V>();

  return {
    get(key: K) {
      return store.get(key);
    },
    set(key: K, value: V) {
      if (!store.has(key) && store.size >= size) {
        store.delete(store.keys().next().value!);
      }

      store.set(key, value);
    },
    clear() {
      store.clear();
    },
  };
}
